import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import _get from 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { a as _objectSpread } from '../chunk-ad6ad343.js';
import 'polished';
import _defaultPalette from './palette.js';
import '../parseIcons.js';
import global from './global.js';
import layout from './layout.js';
import fontSizes from './fontSizes.js';
import fontWeights from './fontWeights.js';
import Container from './Container.js';
import FieldSet from './FieldSet.js';
import '@fortawesome/free-solid-svg-icons/faInfoCircle';
import '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import '@fortawesome/free-solid-svg-icons/faCheckCircle';
import '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import '@fortawesome/free-solid-svg-icons/faTimes';
import '@fortawesome/free-solid-svg-icons/faSearch';
import Icon from './Icon.js';
import LayoutSet from './LayoutSet.js';
import Page from './Page.js';
import Pane from './Pane.js';
import Table from './Table.js';

var _docs = function _docs(overrides) {
  return _objectSpread({
    logoPath: 'logo.svg'
  }, _get(overrides, '_docs', {}));
};

function theme(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }

  return _objectSpread({}, overrides, {
    _docs: _docs(overrides),
    global: global(overrides),
    palette: _defaultPalette(overrides),
    layout: layout(overrides),
    fontSizes: fontSizes(overrides),
    fontWeights: fontWeights(overrides),
    Container: Container(overrides),
    FieldSet: FieldSet(overrides),
    Icon: Icon(overrides),
    LayoutSet: LayoutSet(overrides),
    Page: Page(overrides),
    Pane: Pane(overrides),
    Table: Table(overrides)
  });
}

export default theme;